import React from 'react';
import styled from 'styled-components';
const StyledProjectsGrid = styled.div`
  ${({ theme }) => theme.mixins.resetList};

  .skills {
    width: 100%;
    height: 100%;
    clear: both;
  }
  a {
    position: relative;
    z-index: 1;
  }

  .skills .item {
    min-width: 250px;
    text-align: center;
    float: left;
    margin-bottom: 20px;
  }
  .skills .item > div {
    min-height: 90px;
    max-height: 90px;
  }
  .skills .item img {
    max-width: 90px;
    height: 100%;
  }
  .skills .item .text {
    padding-top: 10px;
  }
  @media only screen and (max-width: 600px) {
    .skills .item {
      float: unset !important;
    }
  }
`;

const skills = [
  {
    skillName: 'C#',
    path: '/static/tech/csharp.svg',
  },
  {
    skillName: '.NET Core',
    path: '/static/tech/net-core.svg',
  },
  {
    skillName: 'Blazor',
    path: '/static/tech/blazor.svg',
  },
  {
    skillName: 'MS SQL',
    path: '/static/tech/sql-server-v1.png',
  },
  {
    skillName: 'PostgreSQL',
    path: '/static/tech/postgresql.svg',
  },
  {
    skillName: 'MySQL',
    path: '/static/tech/my-sql.png',
  },
  {
    skillName: 'MongoDB',
    path: '/static/tech/mongodb-icon.svg',
  },
  {
    skillName: 'Redis',
    path: '/static/tech/redis-icon.svg',
  },

  {
    skillName: 'Azure',
    path: '/static/tech/azure.svg',
  },
  {
    skillName: 'RabbitMQ',
    path: '/static/tech/rabbitmq.svg',
  },
  {
    skillName: 'JavaScript',
    path: '/static/tech/js.svg',
  },
  {
    skillName: 'TypeScript',
    path: '/static/tech/ts.svg',
  },
  {
    skillName: 'jQuery',
    path: '/static/tech/jquery.png',
  },
  {
    skillName: 'Knockout',
    path: '/static/tech/knockout.svg',
  },
  {
    skillName: 'React',
    path: '/static/tech/react.png',
  },
  {
    skillName: 'Vue',
    path: '/static/tech/vue.svg',
  },
  {
    skillName: 'Angular',
    path: '/static/tech/angular.svg',
  },
  {
    skillName: 'Node',
    path: '/static/tech/node.svg',
  },
  {
    skillName: 'HTML 5',
    path: '/static/tech/html5.png',
  },
  {
    skillName: 'CSS 3',
    path: '/static/tech/css3.png',
  },
  {
    skillName: 'SASS',
    path: '/static/tech/sass.png',
  },
  {
    skillName: 'Bootstrap',
    path: '/static/tech/bootstrap.png',
  },
  {
    skillName: 'Git',
    path: '/static/tech/git.svg',
  },
  {
    skillName: 'VS Code',
    path: '/static/tech/vs-code.svg',
  },
];

const Featured = () => (
  <section id="skills">
    <h2 className="numbered-heading"> Skils </h2>

    <StyledProjectsGrid>
      <div className="skills">
        {skills &&
          skills.map(({ skillName, path }, i) => (
            <div className="item" key={i}>
              <div>
                {' '}
                <img loading="lazy" src={path} alt={skillName} />
              </div>
              <span className="text" style={{ display: 'block' }}>
                {skillName}
              </span>
            </div>
          ))}
      </div>
    </StyledProjectsGrid>
  </section>
);

export default Featured;
